/**
 * ContainerGroupPdfUrlGate
 */
import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectContainerGroupValue } from '../../../../../../services/containerGroups/selectors';

interface Props {
    pdfUrl?: ?string;
    FallbackComponent?: React.Node;
    children?: React.Node;
}

export class ContainerGroupPdfUrlGate extends React.PureComponent<Props> {
    render() {
        const { pdfUrl, FallbackComponent, children } = this.props;
        if (!pdfUrl) {
            return FallbackComponent || null;
        }

        return children || null;
    }
}

const mapStateToProps = createStructuredSelector({
    pdfUrl: makeSelectContainerGroupValue('pdfUrl')
});

export default connect(mapStateToProps)(ContainerGroupPdfUrlGate);
